import { Button, Grid, Modal, Spin } from "antd"; // Import Spin for loading feedback
import styles from "./styles.module.scss";
import { useEffect, useMemo, useRef, useState } from "react";
import { SeekBarV1 } from "components/seek-bar";
import { getTimeStamps, getVideoRatio, heightConversion } from "./helpers";
import { UseApiCallV2 } from "hooks";
import { loadavg } from "os";
import { VideoWrapper } from "components/video-wrapper";
import { DownloadOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { ReactComponent as Download } from "../../icons/downloadButton.svg";
import { ReactComponent as Download2D } from "../../icons/download2D.svg";
import { ReactComponent as Download3D } from "../../icons/3dDownLoad.svg";
import { UseLazyApiCallV2 } from "hooks/use-lazy-api-call-v2";
import { ConditionalRenderer } from "components/conditonal-renderer";
import {
  ENVIORNMENTS,
  getCurrentEnviornment,
  REACT_APP_BaseServerURL,
  REACT_APP_BaseServerURL_SANDBOX,
} from "utils/constants";
import { DownloadJsons } from "components/download-jsons";
import { Tabs } from "components/preview-history-multi/Tabs";
import { SeekBarMulti } from "components/seek-bar-multi";
import { useReactQueryV2 } from "hooks/use-react-query-v2";
import { getVideoHeight } from "utils/helpers";
import { calculateFixHeight } from "components/preview-history/helpers";

const { useBreakpoint } = Grid;

export function VisualizeWrapper({
  fileId,
  visible,
  deviceType,
  frames,
  extractionProgress,
  videoHeight,
  videoWidth,
}: any) {
  const screens = useBreakpoint();
  const enviornment = getCurrentEnviornment();
  let { state, pathname, search: searchParams } = useLocation();
  const localPathname = useLocation().pathname;

  pathname =
    pathname === "/m2c-analytics" || pathname?.includes("golf-facility-detail")
      ? "/m2c-golf-history"
      : pathname;
  const data = {
    fileid: pathname === "/m2c-golf-history" ? fileId + "_2d" : fileId,
  };

  const visualizeContainerRef = useRef<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isReadyToPlay, setIsReadyToPlay] = useState(false);
  const [timestamps, setTimeStamps] = useState<any>();
  const [error, setError] = useState<any>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentFrame, setCurrentFrame] = useState(0);
  const containerHeight = visualizeContainerRef?.current?.clientHeight;
  const [isModalVisible, setIsModalVisible] = useState<boolean>(visible);
  const [frameRate, setFrameRate] = useState(null);
  const [downloading, setDownloading] = useState(false);

  // const containerHeightFix: any = screens.xl
  //   ? "calc(100dvh - 340px)"
  //   : window.innerHeight > 600
  //     ? "52dvh"
  //     : "70dvh";

  const containerHeightFix: any = calculateFixHeight({ screens });

  const [heightOfContainer, setHeightOfContainer] =
    useState(containerHeightFix);
  const [widthOfContainer, setWidthOfContainer] = useState<any>();
  const [playbackSpeed, setPlaybackSpeed] = useState("1x");
  const [playbackMode, setplaybackMode] = useState("standard");

  const containerWidth = getVideoRatio(
    visualizeContainerRef?.current?.clientHeight,
  );
  const playbackModeArr = [
    {
      title: "Standard Playback",
      key: "standard",
    },
    {
      title: "Smooth Playback",
      key: "smooth",
    },
  ];

  let urlForAPI: any;
  let twoDURL: any;
  let threeDurl: any;
  switch (pathname) {
    case "/m2c-golf-history":
    case "/user-history":
    case "/pg-history":
      urlForAPI = "/get_video_pose";
      twoDURL = "/get_pose2d_json";
      threeDurl = "/get_pose3d_json";

      break;
    case "/m2c-launch-history":
      urlForAPI = "/get_video_launch";
      twoDURL = "/get_2d_launch";
      threeDurl = "/get_pose3d_json";
      break;
    case "/m2c-athletics-history":
      urlForAPI = "/get_video_athletics";
      twoDURL = "/get_2d_athletics";
      threeDurl = "/get_3d_athletics";

      break;
    default:
      break;
  }
  const combineURL: any = (url: any) => {
    const baseUrl =
      getCurrentEnviornment() === ENVIORNMENTS.LIVE
        ? REACT_APP_BaseServerURL
        : REACT_APP_BaseServerURL_SANDBOX;
    return baseUrl + url;
  };
  const {
    data: videoData,
    isLoading: videoDataLoading,
    error: videoDataError,
  }: any = useReactQueryV2({
    url: urlForAPI,
    method: "POST",
    paramsData: data,
    skip: !fileId,
    queryKey: [urlForAPI, fileId],
    isBioMechanics: false,
    isAbsoluteUrl: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const [download2DFunction] = UseLazyApiCallV2({
    url: null,
    method: "POST",
  }) as any;

  const [download3DFunction] = UseLazyApiCallV2({
    url: null,
    method: "POST",
  }) as any;
  useEffect(() => {
    if (visible) {
      setIsModalVisible(true);
      console.log("MODEL", visible);
    } else {
      console.log("MODEL", visible);
      setIsModalVisible(false);
    }
  }, [visible]);

  const raw = JSON.stringify(data);

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: any = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  useEffect(() => {
    if (videoData) {
      setIsLoading(false);
      setIsReadyToPlay(false);
      setTimeStamps(null);
      setError(null);
      setIsPlaying(false);
      setCurrentFrame(0);

      const totalTimestamps = getTimeStamps(
        videoData?.frame_rate,
        videoData?.total_frames,
      );
      setFrameRate(videoData?.frame_rate);
      setTimeStamps(totalTimestamps);
      setIsLoading(false); // Set loading state to false regardless of success or error
    }
  }, [videoData]);

  function handlePlay() {
    setIsPlaying((prevState) => !prevState);
  }
  function handlePreviousFrame() {
    setCurrentFrame((prevFrame) => prevFrame - 1);
    setIsPlaying(false);
  }

  function handleNextFrame() {
    setCurrentFrame((prevFrame) => prevFrame + 1);
    setIsPlaying(false);
  }

  function handleSliderChange(e: any) {
    const frameIndex = parseInt(e.target.value);
    setCurrentFrame(frameIndex);
  }

  const handleDownload = () => {
    if (videoData && videoData.pre_signed_url) {
      const anchor = document.createElement("a");
      anchor.href = videoData.pre_signed_url;
      anchor.download = "video.mp4";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    }
  };
  const handleDownload2D = async () => {
    try {
      // First file download
      const res1 = await download2DFunction({
        url: twoDURL,
        params: {
          fileid: fileId,
        },
      });

      // Create a link element for the first file and trigger the download
      const link1 = document.createElement("a");
      link1.href = res1;
      link1.download = "file1.json"; // Adjust the filename here if needed
      document.body.appendChild(link1);
      link1.click();
      document.body.removeChild(link1);
      console.log("First file download triggered.");
      return;

      // Wait for a brief moment to ensure the first download is triggered
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Second file download
      const res2 = await download2DFunction({
        url: "/get_tracer_json",
        params: {
          fileid: fileId,
        },
      });

      // Create a link element for the second file and trigger the download
      const link2 = document.createElement("a");
      link2.href = res2;
      link2.download = "file2.json"; // Adjust the filename here if needed
      document.body.appendChild(link2);
      link2.click();
      document.body.removeChild(link2);
      console.log("Second file download triggered.");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDownload3D = async () => {
    try {
      const res = await download3DFunction({
        url: threeDurl,
        params: {
          fileid: fileId,
        },
      });
      const link = document.createElement("a");
      link.href = res;
      link.download = "file.json"; // Adjust the filename here if needed

      // Simulate a click on the link to trigger the download
      link.click();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  function handleResizeWidth() {
    setWidthOfContainer(
      getVideoRatio(visualizeContainerRef?.current?.clientHeight),
    );
  }

  // function handleResize() {
  //   setHeightOfContainer(containerHeightFix);
  // }
  useEffect(() => {
    if (visualizeContainerRef?.current) {
      setWidthOfContainer(
        getVideoRatio(visualizeContainerRef?.current?.clientHeight),
      );
    }
  }, []);

  // useEffect(() => {
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);
  useEffect(() => {
    window.addEventListener("resize", handleResizeWidth);
    return () => window.removeEventListener("resize", handleResizeWidth);
  }, []);

  function handlePlayBackSpeed(existingSpeed: any) {
    let newSpeed = "";
    switch (existingSpeed) {
      case "1x":
        newSpeed = "2x";
        break;
      case "2x":
        newSpeed = "4x";
        break;
      case "4x":
        newSpeed = "8x";
        break;
      default:
        newSpeed = "1x";
        break;
    }
    setPlaybackSpeed(newSpeed);
  }
  function getTimeInterval(playbackSpeed: any) {
    let intervalTime = 33;
    switch (playbackSpeed) {
      case "2x":
        intervalTime = intervalTime / 2;
        break;
      case "4x":
        intervalTime = intervalTime / 4;
        break;
      case "8x":
        intervalTime = intervalTime / 8;
        break;
    }
    return intervalTime;
  }
  const time = playbackMode === "smooth" ? getTimeInterval(playbackSpeed) : 120;
  useEffect(() => {
    if (!isPlaying) return;
    const interval = setInterval(() => {
      setCurrentFrame((prevFrame: any) => {
        const nextFrame = prevFrame + 1;
        const finalFrame = timestamps.length;
        const myFrame = nextFrame;

        if (myFrame >= finalFrame) {
          setIsPlaying(false);
          // Stop playback when reaching the last frame
          return 0;
        }
        return nextFrame;
      });
    }, time);

    return () => {
      clearInterval(interval);
    };
  }, [isPlaying, playbackSpeed]);

  useEffect(() => {
    if (!videoHeight || !videoWidth) return;

    function updateHeight() {
      const { width, height } =
        visualizeContainerRef.current?.getBoundingClientRect() || {};
      if (!screens.xxl) {
        const heightCal = getVideoHeight({
          width: Math.round(width || 0 / 2), //
          height,
          videoHeight,
          videoWidth,
        });

        setHeightOfContainer(heightCal);

        console.log({ heightCal });
      } else {
        setHeightOfContainer(containerHeightFix);
        setWidthOfContainer(
          getVideoRatio(visualizeContainerRef?.current?.clientHeight),
        );
      }

      console.log({ videoHeight, videoWidth, width, height }, "====");
    }
    updateHeight();

    window.addEventListener("resize", updateHeight);
  }, [screens, videoHeight, videoWidth]);

  const containerMaxHeight = screens.xl
    ? "99%"
    : 100 + Number(heightOfContainer?.replace("px", "") || 400) + "px";

  const isM2cAnalytics = localPathname === "/m2c-analytics";

  return (
    <Spin
      spinning={isLoading || downloading}
      style={{ maxWidth: containerWidth }}
    >
      <div
        className={styles.visualizeWrapperContainer}
        ref={visualizeContainerRef}
        style={{
          width: widthOfContainer,
          height: heightOfContainer,
          maxHeight: containerMaxHeight,
        }}
      >
        <div style={{ position: "relative", height: "100%" }}>
          <VideoWrapper
            containerHeight={heightConversion(heightOfContainer)}
            videoSrc={videoData?.pre_signed_url}
            setIsReadyToPlay={setIsReadyToPlay}
            timestamps={timestamps}
            currentFrame={currentFrame}
            isPlaying={isPlaying}
            isLandscape={false}
            frameRate={frameRate}
            extractionProgress={extractionProgress}
            activeExtraction={playbackMode === "smooth"}
            frames={frames}
            isM2cAnalytics={isM2cAnalytics}
          />

          <ConditionalRenderer condition={pathname === "/m2c-golf-history"}>
            <div style={{ position: "absolute", top: "10px", right: "10px" }}>
              <DownloadJsons
                fileId={fileId}
                setDownloading={setDownloading}
                twoDURL={twoDURL}
                videoSources={[videoData?.pre_signed_url]}
                isDesktop={deviceType === "Desktop"}
              />
            </div>
          </ConditionalRenderer>
          <div
            className={styles.switchTab}
            style={{
              width: "70%",
              position: "absolute",
              left: "10px",
              top: "10px",
              zIndex: "1",
            }}
          >
            <Tabs
              activeTab={playbackMode}
              setActiveTab={setplaybackMode}
              tabsArr={playbackModeArr}
              variant=""
            />
          </div>
          <ConditionalRenderer condition={pathname !== "/m2c-golf-history"}>
            <Button
              type="primary"
              style={{
                position: "absolute",
                borderRadius: "2px",
                top: "10px",
                right: "10px",
                zIndex: "999",
                backgroundColor: "white",
                padding: "7px",
                height: "45px",
                width: "45px",
                border: "1px solid #006ab3",
              }}
              onClick={handleDownload}
              className={styles.iconsWrapper}
            >
              <Download
                style={{ width: "35px", height: "35px", borderRadius: "0px" }}
              />
            </Button>

            <Button
              type="primary"
              style={{
                position: "absolute",
                borderRadius: "2px",
                top: "60px",
                right: "10px",
                zIndex: "999",
                backgroundColor: "white",
                padding: "1px",
                height: "45px",
                width: "45px",
                border: "1px solid #006ab3",
              }}
              onClick={handleDownload2D}
              className={styles.iconsWrapper}
            >
              <Download2D
                style={{ width: "40px", height: "40px", borderRadius: "1px" }}
              />
            </Button>
          </ConditionalRenderer>

          <div
            style={{
              position: "absolute",
              bottom: "10px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <SeekBarMulti
              handleNextFrame={handleNextFrame}
              handleSliderChange={handleSliderChange}
              handlePreviousFrame={handlePreviousFrame}
              handlePlay={handlePlay}
              currentFrame={currentFrame}
              isReadyToPlay={!isLoading}
              isPlaying={isPlaying}
              timestamps={timestamps}
              playbackMode={playbackMode}
              handlePlayBackSpeed={handlePlayBackSpeed}
              playbackSpeed={playbackSpeed}
            />
          </div>
        </div>
      </div>
    </Spin>
  );
}
